import moment from "moment";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getRecoil, setRecoil } from "recoil-nexus";
import PickuptimeModal from "../../../../components/modal/PickuptimeModal";
import RiderRejectModal from "../../../../components/modal/RiderRejectModal";
import ApiController from "../../../../controller/ApiController";
import OrderController, {
  OrderStatusType,
} from "../../../../controller/OrderController";
import PrinterController from "../../../../controller/PrinterController";
import { authState } from "../../../../recoil/auth";
import { deliverySettingState } from "../../../../recoil/delivery";
import { exceedState } from "../../../../recoil/exceed";
import {
  APP_NAME_KNOCKKNOCK,
  KnockOrderItemType,
  ORDER_CANCLE_STATUS,
  ORDER_COM_COOK_STATUS,
  ORDER_COM_DEL_STATUS,
  ORDER_COM_STATUS,
  ORDER_READY_STATUS,
  ORDER_START_DEL_STATUS,
  ORDER_WAIT_STATUS,
} from "../../../../recoil/type";
import { ButtonStatusStyle } from "../OrderStyle";
import DeliveryStatusButton from "./DeliveryStatusButton";
import OrderStatusButton from "./OrderStatusButton";
import LogController from "../../../../controller/LogController";
import { getOrderComment } from "../../../../utils/StatusComment";
import { couponState } from "../../../../recoil/coupon";

// 주문 간단히 보기 우측 버튼 및 접수 로직

interface ButtonStatusProps {
  props: KnockOrderItemType;
  isBlink: boolean;
  setBlinkCount: any;
  index: number;
}

const minuteList: any = [];
for (let i = 3; i < 19; i++) {
  minuteList.push({
    key: i,
    value: i * 5,
    name: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
    label: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
  });
}

const ButtonStatus = ({
  props,
  isBlink,
  setBlinkCount,
  index,
}: ButtonStatusProps) => {
  const [pickupTimeModal, setPickupTimeModal] = useState<boolean>(false);

  const [exceedCheck, setExceedCheck] = useState<boolean>(false);

  const [deliveryStatus, setDeliveryStatus] = useState<number>(
    props.child.order_status === ORDER_COM_STATUS ? 4 : 0
  );

  const [estimatedTime, setEstimatedTime] = useState<number>(0);

  const [visibleRejectRider, setVisibleRejectRider] = useState<{
    visible: boolean;
    msg: string;
  }>({
    visible: false,
    msg: "",
  });

  const [remainTime, setRemainTime] = useState<number>(
    props.child.order_status === ORDER_WAIT_STATUS
      ? Math.floor(
          (new Date(props.child.ordered_at).getTime() -
            new Date().getTime() +
            props.child.delivery_estimated_time * 1000 * 60) /
            (60 * 1000)
        )
      : Math.floor(
          (new Date(props.child.delivery_expected_at!).getTime() -
            new Date().getTime()) /
            (60 * 1000)
        )
  );
  const [completeDifferTime, setCompleteDifferTime] = useState<number>(
    Math.floor(
      (new Date(props.child.delivery_completed_at!).getTime() -
        new Date(props.child.delivery_expected_at!).getTime()) /
        (60 * 1000)
    )
  );

  const [minute, setMinute] = useState<any>({
    key: -1,
    value: props.child.delivery_estimated_time,
    name: `${props.child.delivery_estimated_time}분`,
    label: `${props.child.delivery_estimated_time}분`,
  });

  const onChange_status = () => {
    LogController.click({
      path: "State button",
      params: "상태변경 버튼 클릭",
      params2:
        props.order_id +
        "/" +
        getOrderComment(APP_NAME_KNOCKKNOCK, props.child.order_status),
    });
    if (props.child.order_status === ORDER_WAIT_STATUS)
      setPickupTimeModal(true);
    else if (props.child.next_order_status === -1) {
    } else updateStatus();
  };

  const checkUpdateRiderStatus = (clickedTime?: number) => {
    console.log("rider check");
    const deliverySetting = getRecoil(deliverySettingState);
    if (props.child.order_status === ORDER_WAIT_STATUS) {
      if (deliverySetting.type === "barogo" && deliverySetting.mode === 1) {
        statusCheckNCall(clickedTime);
      } else {
        updateStatus(clickedTime);
      }
    } else if (
      // props.child.order_status === ORDER_COM_STATUS ||
      // props.child.order_status === ORDER_CANCLE_STATUS
      props.child.next_order_status === -1
    ) {
    } else {
      updateStatus(clickedTime);
    }
  };

  // delivery_type 변경
  const updateDeliveryType = async (value: number) => {
    try {
      const oParams = {
        order_id: props.order_id,
        order_seq: props.child.order_seq,
        delivery_type: value,
      };
      const oRes = await ApiController.order.updateDeliveryType(oParams);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        if (oResponse.ok) {
          if (value === 1) {
            toast.success(
              `${props.child.bill_number} 주문을 직접배달로 변경했어요`
            );
          }

          setVisibleRejectRider({ visible: false, msg: "" });
          updateStatus();
        }
      }
    } catch (e) {
      console.error("err => ", e);
    }
  };

  const onChange_minute = (event: any) => {
    setMinute(event);
  };

  const isDisabledStatusButton = () => {
    // if (props.child.delivery_type === 1) {
    if (
      props.child.order_status === ORDER_COM_DEL_STATUS ||
      props.child.order_status === ORDER_COM_STATUS
    )
      return true;
    else return false;
    // } else {
    //   return false;
    // }
  };

  // orderStatus API
  const updateStatus = async (clickedTime?: number) => {
    console.log("estimatedTime", estimatedTime);

    const oParams: OrderStatusType = {
      order_id: props.order_id,
      order_seq: props.child.order_seq,
      order_status: props.child.next_order_status,
      delivery_estimated_time: clickedTime ? clickedTime : minute.value,
      table_area_nr: props.table_area_nr,
      table_nr: props.table_nr,
      store_id: props.store_id,
      parent_store_id: props.parent_store_id,
      user_token_id: getRecoil(authState).user_token_id,
      status_changed_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    if (clickedTime || estimatedTime !== 0)
      oParams.expected_at = moment(
        new Date(
          new Date().getTime() +
            (clickedTime ? clickedTime : estimatedTime) * 60 * 1000
        )
      ).format("YYYY-MM-DD HH:mm:ss");

    const oRes = await OrderController.updateStatus(oParams);

    if (oRes && oRes.data) {
      setEstimatedTime(0);
      console.log(
        "props.child.order_status",
        props.order_id,
        props.child.order_status
      );
      if (props.child.order_status === ORDER_COM_DEL_STATUS) {
        setBlinkCount(0);
      } else {
        setBlinkCount(3);
        if (props.child.order_status === ORDER_WAIT_STATUS) {
          console.log(
            "~~~~~~~~~~~~~~~click print~~~~~~~~~~~~~~~~",
            props.order_id
          );
          // 접수 버튼 출력
          PrinterController.preparePrintData(props, 1, true, true);
          LogController.print({
            path: "confirm button",
            params: "접수 버튼 후 출력",
            params2: props.order_id,
          });
        }
      }

      if (
        oRes.data.data &&
        oRes.data.data.metaData &&
        oRes.data.data.metaData.genCoupon
      ) {
        const getTestType = () => {
          if (props.child.bill_number === "TEST-1") return 0;
          else if (props.child.bill_number === "TEST-2") return 1;
          else return 0;
        };
        setRecoil(couponState, {
          type: getTestType(),
          ...oRes.data.data.metaData.genCoupon,
        });
      }
      console.log("oRes", oRes);
    }
  };

  // 배달 api
  const statusCheckNCall = async (clickedTime?: number) => {
    const oParams = {
      order_id: props.order_id,
      store_id: props.store_id,
    };
    const oRes = await ApiController.delivery.statusCheckNCall(oParams);
    if (oRes && oRes.data) {
      const oResponse = oRes.data;
      if (oResponse.data) {
        if (oResponse.data.success) {
          toast(oResponse.data.message);
          updateDeliveryType(0);
          updateStatus(clickedTime);
          LogController.delivery({
            path: "Confirm Order",
            params: "바로고 주문접수 성공",
            params2: props.order_id,
          });
        } else {
          // updateStatus();
          // updateDeliveryType(0);
          setVisibleRejectRider({
            visible: true,
            msg: oResponse.data.message,
          });
        }
      } else {
        // updateStatus();

        console.log("err");
        toast.error("배달기사 호출에 실패했어요");
        setVisibleRejectRider({
          visible: true,
          msg: "배달 연동이 불가합니다\n매크로를 사용해주세요",
        });
      }
    }
  };

  const changeDeliveryDirect = () => {
    setVisibleRejectRider({
      visible: false,
      msg: "",
    });
    updateDeliveryType(1);
  };

  useEffect(() => {
    setMinute({
      key: -1,
      value: props.child.delivery_estimated_time,
      name: `${props.child.delivery_estimated_time}분`,
      label: `${props.child.delivery_estimated_time}분`,
    });
  }, [props.child.delivery_estimated_time]);

  // useEffect(() => {
  //   if (
  //     currentStore.value &&
  //     currentStore.value.auto_confirmed === 1 &&
  //     props.child.order_status === ORDER_WAIT_STATUS
  //   ) {
  //     updateStatus(props.child.delivery_estimated_time);
  //   }
  // }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    setRemainTime(
      props.child.order_status === ORDER_WAIT_STATUS
        ? Math.floor(
            (new Date(props.child.ordered_at).getTime() -
              new Date().getTime() +
              props.child.delivery_estimated_time * 1000 * 60) /
              (60 * 1000)
          )
        : Math.floor(
            (new Date(props.child.delivery_expected_at!).getTime() -
              new Date().getTime()) /
              (60 * 1000)
          )
    );
    if (
      props.child.order_status === ORDER_COM_DEL_STATUS ||
      props.child.order_status === ORDER_COM_STATUS
    ) {
      setCompleteDifferTime(
        Math.floor(
          (new Date(props.child.delivery_completed_at!).getTime() -
            new Date(props.child.delivery_expected_at!).getTime()) /
            (60 * 1000)
        )
      );
    }

    interval = setInterval(() => {
      setRemainTime(
        props.child.order_status === ORDER_WAIT_STATUS
          ? Math.floor(
              (new Date(props.child.ordered_at).getTime() -
                new Date().getTime() +
                props.child.delivery_estimated_time * 1000 * 60) /
                (60 * 1000)
            )
          : Math.floor(
              (new Date(props.child.delivery_expected_at!).getTime() -
                new Date().getTime()) /
                (60 * 1000)
            )
      );
      if (
        props.child.order_status === ORDER_COM_DEL_STATUS ||
        props.child.order_status === ORDER_COM_STATUS
      ) {
        setCompleteDifferTime(
          Math.floor(
            (new Date(props.child.delivery_completed_at!).getTime() -
              new Date(props.child.delivery_expected_at!).getTime()) /
              (60 * 1000)
          )
        );
      }
      // console.log("timer", remainTime, completeDifferTime);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [props.order_id, props.child.order_status]);

  useEffect(() => {
    if (!exceedCheck) {
      if (
        remainTime === -1 &&
        getRecoil(exceedState).orderId !== props.order_id &&
        props.child.order_status !== ORDER_CANCLE_STATUS &&
        props.child.order_status !== ORDER_COM_STATUS &&
        props.child.order_status !== ORDER_COM_DEL_STATUS
      ) {
        setExceedCheck(true);
        setRecoil(exceedState, {
          isOpen: true,
          orderId: props.order_id,
          index: index,
          hotel_name: props.child.hotel_name,
          ordered_at: props.child.ordered_at,
          delivery_expected_at: props.child.delivery_expected_at,
        });
        LogController.event({
          path: "Order exceed",
          params: "배달시간 초과 알림",
          params2: props.order_id,
        });
      }
    }
  }, [remainTime]);

  useEffect(() => {
    if (props.app_name === "KNOCK") {
      if (props.child.order_status === ORDER_READY_STATUS) {
        setDeliveryStatus(1);
      } else if (props.child.order_status === ORDER_COM_COOK_STATUS)
        setDeliveryStatus(2);
      else if (props.child.order_status === ORDER_START_DEL_STATUS)
        setDeliveryStatus(3);
      else if (props.child.order_status === ORDER_COM_DEL_STATUS)
        setDeliveryStatus(4);
      else if (props.child.order_status === ORDER_COM_STATUS) {
        setDeliveryStatus(4);
      } else {
        setDeliveryStatus(0);
      }
    }
  }, [props.child.order_status]);

  return (
    <>
      <ButtonStatusStyle>
        <div className="listRight">
          {/* 배달 정보 */}
          <DeliveryStatusButton
            props={props}
            deliveryStatus={deliveryStatus}
            completeDifferTime={completeDifferTime}
            remainTime={remainTime}
          />
          {/* 주문정보 버튼 */}
          <OrderStatusButton
            props={props}
            deliveryStatus={deliveryStatus}
            isBlink={isBlink}
            minute={minute}
            onChange_minute={onChange_minute}
            onChange_status={onChange_status}
            isDisabledStatusButton={isDisabledStatusButton}
          />
        </div>
      </ButtonStatusStyle>
      <PickuptimeModal
        isVisible={pickupTimeModal}
        setVisible={setPickupTimeModal}
        props={props}
        minute={minute.value}
        updateStatus={checkUpdateRiderStatus}
        estimatedTime={estimatedTime}
        setEstimatedTime={setEstimatedTime}
      />
      <RiderRejectModal
        title={"배달 대행 접수가 실패했어요"}
        isVisible={visibleRejectRider}
        setVisible={setVisibleRejectRider}
        onCancel={changeDeliveryDirect}
        cancelComment="직접 배달하기"
        onConfirm={checkUpdateRiderStatus}
        confirmComment="배달기사 재요청"
        isRetry={true}
      />
    </>
  );
};

export default ButtonStatus;
